import { Directive, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[scroll]'
})
export class ScrollDirective {
  @Output() setScroll = new EventEmitter();
  private scroll: number;
  constructor(private el: ElementRef) { }
  // @HostListener('scroll', ['$event'])
  // scrollIt() { this.scroll = event.srcElement.scrollTop }

  reset() {  this.el.nativeElement.scrollL = this.scroll }
}

